import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Faq, FaqService } from '@app/cms-base';
import { BaseComponent } from '@messaia/cdk';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-faq',
	templateUrl: './faq.component.html',
	styleUrls: ['./faq.component.scss'],
})
export class FaqComponent extends BaseComponent {
	/**
	 * Form title
	 */
	public subtitle: string = $localize`:@@faq:Faq`

	/**
	 * FAQ section
	 */
	@Input()
	public group: string;

	/**
	 * clientId: number
	 */
	@Input()
	public clientId: number;

	/**
	 * FAQ items as observable
	 */
	public itemsObservable: Observable<Faq[]>;

	/**
	 * Constructor
	 */
	constructor(
		public service: FaqService,
		public dialog: MatDialog,
		protected route: ActivatedRoute,
		protected changeDetectorRef: ChangeDetectorRef
	) {
		super(route, changeDetectorRef)
	}

	/**
	 * Lifecycle hook that is called after data-bound properties 
	 * of a directive are initialized.
	 */
	ngOnInit(): void {
		super.ngOnInit();

		if (this.group) {
			this.itemsObservable = this.service.getList({ clientId: this.clientId, enabled: true, group: this.group, sortBy: 'Ordering' });
		}
	}
}